<div class="ion-padding alapertelmezett-intezmeny">
  <h2><ion-icon name="enter-outline"></ion-icon> Alapértelmezetten megnyíló intézmény / alrendszer</h2>
  <p class="halvany">
    Ha egy felhasználónak több intézménye/alrendszere van, itt állítható be, melyik nyíljon meg belépéskor.
    <b>Mindenkinek</b> = intézményi alapértelmezett (minden felhasználóra érvényes), <b>Nekem</b> = csak a te fiókodra.
    Belépéskor a felhasználó saját választása erősebb az intézményinél.
  </p>

  <div *ngIf="betolt" class="halvany">Betöltés…</div>

  <ion-card *ngIf="!betolt && intezmenyek.length">
    <ion-card-content>
      <div class="tabla-wrap">
        <table class="lista">
          <thead>
            <tr><th>Intézmény</th><th>Alrendszer</th><th>Jelenlegi</th><th></th></tr>
          </thead>
          <tbody>
            <tr *ngFor="let i of intezmenyek">
              <td><b>{{ i.intezmenyName }}</b></td>
              <td>
                <ion-select *ngIf="i.mode?.length > 1" [(ngModel)]="i.valasztottMode" interface="popover" placeholder="Alrendszer">
                  <ion-select-option *ngFor="let m of i.mode" [value]="m">{{ modeNev(m) }}</ion-select-option>
                </ion-select>
                <span *ngIf="i.mode?.length <= 1" class="halvany"><small>{{ modeNev(i.valasztottMode) }}</small></span>
              </td>
              <td>
                <ion-badge *ngIf="i.alapertelmezett_user == 1" color="primary">Nekem</ion-badge>
                <ion-badge *ngIf="i.alapertelmezett_intezmeny == 1" color="success">Mindenkinek</ion-badge>
                <span *ngIf="i.alapertelmezett_user != 1 && i.alapertelmezett_intezmeny != 1" class="halvany">–</span>
              </td>
              <td class="jobb">
                <ion-button size="small" [fill]="i.alapertelmezett_user == 1 ? 'solid' : 'outline'" [disabled]="fut" (click)="nekem(i)">
                  <ion-icon slot="start" [name]="i.alapertelmezett_user == 1 ? 'star' : 'star-outline'"></ion-icon>
                  {{ i.alapertelmezett_user == 1 ? 'Nekem (törlés)' : 'Nekem' }}
                </ion-button>
                <ion-button size="small" color="success" [fill]="i.alapertelmezett_intezmeny == 1 ? 'solid' : 'outline'"
                  [disabled]="fut || i.alapertelmezett_intezmeny == 1" (click)="mindenkinek(i)">
                  <ion-icon slot="start" name="business-outline"></ion-icon>
                  Mindenkinek
                </ion-button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </ion-card-content>
  </ion-card>

  <p *ngIf="!betolt && intezmenyek.length <= 1" class="halvany">
    Ehhez a felhasználóhoz csak egy intézmény/alrendszer tartozik – nincs mit alapértelmezettként választani.
  </p>
</div>
